export const DEFAULT_PLAN = 'FREE';

export const PLAN_ORDER = ['FREE', 'TIER_1', 'TIER_2', 'TIER_3', 'TIER_4'];

export const PLAN_CONFIG = {
  FREE: {
    name: 'Free',
    limit: 50,
    formLimit: 3,
    priceLabel: 'Free',
    priceMonthly: 0,
    price: 'Free',
    description: '50 forms per month',
    features: ['50 submissions/month', '3 forms', 'All field types', 'Password protection', 'Webhooks', 'Stackable forms', 'Email support'],
    payfastItemName: 'Tier Free 50 submissions'
  },
  TIER_1: {
    name: 'Tier 1',
    limit: 200,
    formLimit: 3,
    priceLabel: 'R299 / month',
    priceMonthly: 299,
    price: 'R299',
    description: '200 submissions per month',
    features: ['200 submissions/month', '3 forms', 'All field types', 'Password protection', 'Webhooks', 'Stackable forms', 'Email support'],
    payfastItemName: 'Tier 1 200 submissions'
  },
  TIER_2: {
    name: 'Tier 2',
    limit: 400,
    formLimit: 3,
    priceLabel: 'R399 / month',
    priceMonthly: 399,
    price: 'R399',
    description: '400 submissions per month',
    features: ['400 submissions/month', '3 forms', 'All field types', 'Password protection', 'Webhooks', 'Stackable forms', 'Priority support', 'Custom branding'],
    payfastItemName: 'Tier 2 400 submissions'
  },
  TIER_3: {
    name: 'Tier 3',
    limit: 1000,
    formLimit: 5,
    priceLabel: 'R499 / month',
    priceMonthly: 499,
    price: 'R499',
    description: '1000 submissions per month',
    features: ['1000 submissions/month', '5 forms', 'All field types', 'Password protection', 'Webhooks', 'Stackable forms', 'Advanced analytics', 'Priority support', 'Custom branding'],
    payfastItemName: 'Tier 3 1000 submissions'
  },
  TIER_4: {
    name: 'Tier 4',
    limit: -1,
    formLimit: 10,
    priceLabel: 'R1400 / month',
    priceMonthly: 1400,
    price: 'R1400',
    description: 'Unlimited submissions',
    features: ['Unlimited submissions', '10 forms', 'All field types', 'Password protection', 'Webhooks', 'Stackable forms', 'Advanced analytics', 'Dedicated support', 'Custom integrations', 'API access'],
    payfastItemName: 'Tier 4 Unlimited submissions'
  }
};

export const getPlanLimit = (planKey) => {
  const plan = PLAN_CONFIG[planKey] || PLAN_CONFIG[DEFAULT_PLAN];
  return plan.limit;
};

export const isUnlimitedLimit = (limit) => limit !== undefined && limit !== null && Number(limit) < 0;

export const formatLimitLabel = (limit) => {
  if (isUnlimitedLimit(limit)) {
    return 'Unlimited';
  }
  return `${limit}`;
};
